import { StandardEntity } from '@infodata-group/inf-commons';

export class AlarmLite extends StandardEntity {
  public date: string;
  public hour: string;
  public type: StandardEntity;
  public agent: StandardEntity;

  constructor(id, label) {
    super(id, label, 'label');
  }
}
